function memoize(fn) {
  const cache = {};
  return (arg) => {
    if (cache[arg] === void 0) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}
export {
  memoize as default
};
//# sourceMappingURL=memoize.es.js.map
